import api from './api'

// Project Central notifications (the bell): mentions, assignments, comments and status
// changes on watched tasks, API token expiry. Marketing Email has emailNotificationService.
export const notificationService = {
  getNotifications: async (params = {}) => {
    const response = await api.get('/notifications', { params })
    return response.data
  },

  getUnreadCount: async () => {
    const response = await api.get('/notifications/unread-count')
    return response.data
  },

  markRead: async (ids) => {
    const response = await api.post('/notifications/read', { ids })
    return response.data
  },

  markAllRead: async () => {
    const response = await api.post('/notifications/read-all')
    return response.data
  },

  getPreferences: async () => {
    const response = await api.get('/notifications/preferences')
    return response.data
  },

  // preferences: { mentioned: { email: false }, ... }
  updatePreferences: async (preferences) => {
    const response = await api.put('/notifications/preferences', { preferences })
    return response.data
  }
}
